import { useCallback, useEffect, useRef, useState } from 'react';

import { elementToImage } from './html-to-image';

type UseHtmlToImageResultType = [string | null, (element: Element) => Promise<void>];

export const useHtmlToImage = (
  padding?: number,
  areGoogleFontsExcluded?: boolean,
  exportUseWidestAncestorWidth?: boolean,
): UseHtmlToImageResultType => {
  const [url, setUrl] = useState<string | null>(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const elementRef = useCallback(
    async (node: Element) => {
      if (node !== null && !url) {
        const dataUrl = await elementToImage(node, padding, areGoogleFontsExcluded, true, {
          exportUseWidestAncestorWidth: exportUseWidestAncestorWidth === true,
        });
        if (isMountedRef.current) {
          setUrl(dataUrl);
        }
      }
    },
    [padding, url, areGoogleFontsExcluded, exportUseWidestAncestorWidth],
  );

  return [url, elementRef];
};
